import CarLoanDashboardPage from '../../pages/loan/dashboard.f7.html';
import CarLoanItemPage from '../../pages/loan/item.f7.html';
import CarLoanPaymentRetunrPage from '../../pages/loan/components/payment-return.f7.html';

import Check from '../controllers/check.js';
import carLoanItemLibrary from '../controllers/car-loan-item-lib.js';

const loanItem = {
  async ownership ( { router, to, resolve, reject } ) {
    const loanId = to.params.id;

    if (Number(loanId) < 1 ) {
      resolve(to.path);
      return;
    }

    let hasOwnership = await carLoanItemLibrary.hasOwnership(loanId);
    if (hasOwnership < 1){
      console.log(hasOwnership.logMessage);
      reject();
      router.navigate(hasOwnership.route, { reloadCurrent: true });
    }

    resolve(to.path);
  }
};

const loan = [
  {
    name: 'loan-dashboard',
    path: '/loan-dashboard/',
    component: CarLoanDashboardPage,
    allowedRoles: [1, 4],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'loan-item',
    path: '/loan-item/:id',
    component: CarLoanItemPage,
    allowedRoles: [1, 4],
    beforeEnter: [Check.authorization, Check.permission, loanItem.ownership],
  },
  {
    name: 'loan-item-payment-return',
    path: '/payment-return/',
    component: CarLoanPaymentRetunrPage,
    allowedRoles: [4],
    beforeEnter: [Check.authorization, Check.permission],
  },
];

export default loan;
